import { chatbotDynamicForm } from "@/app/services/chatbotDynamicForm";
import { ChevronDown } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import { createPortal } from "react-dom";
import "react-calendar/dist/Calendar.css";
import "../../styles/react-calendar.css"; 
import Modal from "../Elements/Modal";
import InputChat from "../Elements/Core/InputChat";
import ButtonChat from "../Elements/Core/ButtonChat";
import SelectChat from "../Elements/Core/SelectChat";
import { Action } from "@/app/constants/enums";
import { iActionRequest } from "@/app/models/interfaceChatBotAction";
import { useUser } from "@/app/context/UserContext";
import { chatbotSaveAction } from "@/app/services/chatbotsaveaction";
import { ChatbotCallApiForm } from "@/app/services/chatbotCallApiForm";
import { getcurrentUser } from "@/app/helpers/functions";


export default function ViewFrm({ formSchema, form_id, form }: { formSchema: FormSchemaFrm, form_id:string, form: Record<string, any> }) {
    const { user, setUser, userProject,accessType } = useUser();
    const [formData, setFormData] = useState<Record<string, any>>({});
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [searchResults, setSearchResults] = useState<Record<string, any[]>>({});
    const [searchLoading, setSearchLoading] = useState<Record<string, boolean>>({});
    const searchInputRef = useRef<Record<string, HTMLDivElement | null>>({});
    const [searchPosition, setSearchPosition] = useState<Record<string, { top: number, left: number, width: number }>>({});

    const updateSearchPosition = (fieldId: string) => {
      const rect = searchInputRef.current[fieldId]?.getBoundingClientRect();
      if (rect) {
        setSearchPosition(prev => ({
          ...prev,
          [fieldId]: {
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
            width: rect.width
          }
        }));
      }
    };

    useEffect(() => {
      const defaultValues: Record<string, any> = {}; 
      formSchema.fields.forEach((field) => {
        if (field.type === "checkbox") {
          defaultValues[field.nameStart] = field.defaultValue || [];
        } else {
          defaultValues[field.nameStart] = field.defaultValue ?? "";
        }
      }); 
      setFormData(defaultValues);
    }, [formSchema.fields]); 

    //const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    //  const { name, type, value, checked, files } = e.target as HTMLInputElement;
    //  let newValue: any = value;
  //
    //  if (type === "checkbox") {
    //    newValue = checked;
    //  } else if (type === "file" && files) {
    //    newValue = files[0];
    //  }
  //
    //  setFormData((prev) => ({ ...prev, [name]: newValue }));
    //};
    const handleSearch = async (query: string, field: any) => {
      if (query.length < 4) {
        setSearchResults(prev => ({ ...prev, [field.field_id]: [] }));
        return;
      }

      const { url, method, headers, campo } = field.apiConfig;
      
      setSearchLoading(prev => ({ ...prev, [field.field_id]: true }));
      
      try {
        const separator = url.includes('?') ? '&' : '?';
        const fetchUrl = `${url}${separator}${campo}=${encodeURIComponent(query)}`;
        const formattedHeaders: Record<string, string> = {};
        if (Array.isArray(headers)) {
          headers.forEach((h: any) => {
            if (h.key && h.value) formattedHeaders[h.key] = h.value;
          });
        }
        const response = await fetch(fetchUrl, {
          method: method || 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...formattedHeaders
          }
        });

        const data = await response.json();
        setSearchResults(prev => ({ ...prev, [field.field_id]: Array.isArray(data) ? data : [] }));
      } catch (error) {
        console.error("Error en api-search:", error);
      } finally {
        setSearchLoading(prev => ({ ...prev, [field.field_id]: false }));
      }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, type, value, checked } = e.target as HTMLInputElement;
      
        setFormData((prev) => {
          if (type === "checkbox") {
            const prevValues = prev[name] || []; // Si no hay valores previos, usa un array vacío
            const newValues = checked 
              ? [...prevValues, value] // Agregar al array
              : prevValues.filter((v: string) => v !== value); // Remover del array
            return { ...prev, [name]: newValues };
          }
      
          return { ...prev, [name]: value };
        });
      };
      
      const validate = () => {
        const newErrors: Record<string, string> = {};
      
        formSchema.fields.forEach((field) => {
          const value = formData[field.nameStart] || "";
          const valueEnd = formData[field.nameEnd] || "";
      
          const getRule = (type: ValidationRuleType) => field?.validations?.find((v) => v.type === type);
          
          
          const required = getRule("required")?.value;
          const minLength = getRule("minLength")?.value as number;
          const maxLength = getRule("maxLength")?.value as number;
          const min = getRule("min")?.value as number;
          const max = getRule("max")?.value as number;
          const pattern = getRule("pattern")?.value as string;
          const compareRule = getRule("compareField")?.value as string;
          
      
          if (required && !value) {
            newErrors[field.nameStart] = "Este campo es obligatorio";
          }
      
          if (minLength && value.length < minLength) {
            newErrors[field.nameStart] = `Mínimo ${minLength} caracteres`;
          }
      
          if (maxLength && value.length > maxLength) {
            newErrors[field.nameStart] = `Máximo ${maxLength} caracteres`;
          }
      
          if (min !== undefined && Number(value) < min) {
            newErrors[field.nameStart] = `El valor mínimo es ${min}`;
          }
      
          if (max !== undefined && Number(value) > max) {
            newErrors[field.nameStart] = `El valor máximo es ${max}`;
          }
      
          if (pattern === "email" && !/^\S+@\S+\.\S+$/.test(value)) {
            newErrors[field.nameStart] = "Formato de correo inválido";
          }
            
          if (compareRule) {
            const otherField = formSchema.fields.find(O=>O.field_id===compareRule)?.nameStart as string; 
            const otherFieldValue = formData[otherField];
            const operator = getRule("compareField")?.operator as string;
            const a = Number(value);
            const b = Number(otherFieldValue);
            let condition = true; 
            if (!isNaN(a) && !isNaN(b)) {
              switch (operator) {
                case ">": condition = a > b; break;
                case ">=": condition = a >= b; break;
                case "<": condition = a < b; break;
                case "<=": condition = a <= b; break;
                case "==": condition = a === b; break;
                case "!=": condition = a !== b; break;
              }
      
              if (!condition) {
                const otherLabel = formSchema.fields.find(O=>O.field_id===compareRule)?.label as string;
                newErrors[field.nameStart] = `El valor debe ser ${operator} al campo ${otherLabel}`;
              }
            }
          }
      
          if (field.type === "date-range") {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
      
            if (required && !valueEnd) {
              newErrors[field.nameStart] = "Este campo es obligatorio";
            }
      
            const dateValue = value ? new Date(value) : null;
            const dateEnd = valueEnd ? new Date(valueEnd) : null;
      
            if (dateValue && dateEnd) {
              dateValue.setHours(0, 0, 0, 0);
              dateEnd.setHours(0, 0, 0, 0);
      
              if (dateValue < today || dateEnd < today) {
                newErrors[field.nameStart] = "Las fechas deben ser hoy o en el futuro";
              } else if (dateValue > dateEnd) {
                newErrors[field.nameStart] = "La fecha de inicio debe ser menor o igual a la fecha de fin";
              }
            } else if (dateValue && dateValue < today) {
              newErrors[field.nameStart] = "La fecha inicio debe ser hoy o en el futuro";
            } else if (dateEnd && dateEnd < today) {
              newErrors[field.nameStart] = "La fecha fin debe ser hoy o en el futuro";
            }
          }

          if (field.type === "checkbox" && required && (!Array.isArray(value) || value.length === 0)) {
            newErrors[field.nameStart] = "Este campo es obligatorio";
          }

        });
      
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
      
 
    const [frmLoading, setFrmLoading] = useState(false);  
    const [frmResult, setFrmResult] = useState<any>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);  
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

  
    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();

      if (!validate()) return false;
      const formattedData = { ...formData };

      formSchema.fields.forEach((field) => {
        if (field.type === "date-range") {
          if (formData[field.nameStart]) {
            const startDate = new Date(formData[field.nameStart]); 
            if (!isNaN(startDate.getTime())) { 
              formattedData[field.nameStart] = startDate.toLocaleDateString("en-CA");
            }
          }
      
          if (field.nameEnd && formData[field.nameEnd]) {
            const endDate = new Date(formData[field.nameEnd]);
            if (!isNaN(endDate.getTime())) {
              formattedData[field.nameEnd] = endDate.toLocaleDateString("en-CA");
            }
          }
        }
      });

      let response: any;
      try {
            setFrmLoading(true);  
            let is_backend= formSchema.is_backend || false
            if(is_backend){
              form["values"]= formattedData
              response = await ChatbotCallApiForm(form);
            }
            else{
              response = await chatbotDynamicForm(formSchema,formattedData);
            }
            
            let redirect = formSchema.redirect? formSchema.redirect : false
            if(redirect){
              if(response?.link){
                window.open(response.link, '_blank');
              }
            }
            else{
              setFrmResult(response);
            }
            const metadata = {
              userId: user.email,
              channelType: "PLAYGROUND",
              sessionId: "",
            };  
            const configuration = { business_case: userProject.project.business_case, company_code: userProject.project.company_code };
            const paramLog = {
              request: {
                method: formSchema.method,
                api: formSchema.action,
                enctype:formSchema.enctype,
                body: formattedData,
              },
              response: response,
              metadata,
              api_name: formSchema.title,
              configuration,
            };
            const request: iActionRequest = {
              company_code: userProject?.project?.company_code ?? "",
              project_id: userProject.project.id  ?? "",
              //user_id: user.email,
              user_id: getcurrentUser(accessType, userProject, user),
              action_code: Action.LEFT_FORM_ENVIO,
              action_detail: paramLog,
            };             
            chatbotSaveAction(request).catch((error) => { console.error("Error al guardar en acción:", error); }); 
        } catch (error) { 
            setFrmResult("");
            console.error('Error obteniendo respuesta', error);
        }
        finally {
            setFrmLoading(false); 
            let redirect = formSchema.redirect? formSchema.redirect : false
            if (!redirect || response?.link== null) {
              setFrmResult(response)
              openModal();
            }
            
        }  
    };
  

    // calendar 
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
    const calendarRef = useRef<HTMLDivElement | null>(null); 
    const showCalendarPostion = (showCalendar:boolean) => {
    if (showCalendar) {
        if(inputRef.current){
        const rect = inputRef.current.getBoundingClientRect();
        setCalendarPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
        });
        setShowCalendar(showCalendar);
        } 
    }else{
        setShowCalendar(showCalendar);
    }

    }

    useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target as Node) && !inputRef.current?.contains(event.target as Node)) {
        setShowCalendar(false);
        }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
    }, []);

    const handleDateChange = (dates: [Date | null, Date | null], field: FieldFrm) => {
        if (dates && dates.length === 2) {
          const [startDate, endDate] = dates;
          
          //setFormData((prev) => ({
          //  ...prev,
          //  [field.nameStart]: startDate ? startDate.toISOString().split("T")[0] : "",
          //  [field.nameEnd]: endDate ? endDate.toISOString().split("T")[0] : "",
          //}));
          
          setFormData((prev) => ({
            ...prev,
            [field.nameStart]: startDate || null,  // Guardar como objeto Date
            [field.nameEnd]: endDate || null,
          }));

        }
      };


    return (
      <div className="">
        <form 
            onSubmit={handleSubmit} 
            className="space-y-4"
            >

          {formSchema.fields&&formSchema.fields.map((field) => (
            <div key={field.field_id} 
                className={`${field.hidden ? "hidden" : ""}`}> 
              <label key={`${field.field_id}-label`}  className="block text-gray-700">{field.label}</label>
  
              {/* Inputs según el tipo */}
              {field.type === "select" ? (
                <> 
                
                  <SelectChat
                    actionCode={Action.LEFT_FORM_DINAMICO}
                    name={field.nameStart}
                    value={formData[field.defaultValue] || ""}
                    options={field.options ?? []}
                    onChange={({ target }) => {
                      setFormData((prev) => ({ ...prev, [target.name!]: target.value }));
                    }}
                    className={`w-full border n-fmr-input px-3 py-2 ${errors[field.nameStart] ? "border-red-500" : "border-gray-300"} focus:outline-none focus:ring-1 focus:ring-blue-700`}
                  />
                  
                {/*}
                  <SelectChat
                    actionCode={Action.LEFT_FORM_DINAMICO}
                    options={field.options || []}
                    name={field.nameStart}
                    isMulti={false}
                    placeholder="Seleccione"
                    value={formData[field.defaultValue] || ""}
                    onChange={handleChange}
                    error={errors[field.nameStart]?.length > 0} // Usamos la propiedad error para indicar si hay un error
                    className="n-fmr-input" // Puedes seguir pasando otras clases
                  />*/}

                {/*<div className="relative">
                    <SelectChat
                      actionCode={Action.LEFT_FORM_DINAMICO}
                      name={field.nameStart}
                      value={formData[field.defaultValue] || ""}
                      onChange={handleChange}
                      className= {` appearance-none
                        w-full border n-fmr-input px-4 pr-4 py-2  ${(errors[field.nameStart]??'').length>0 ? "border-red-500" : "border-gray-300"} focus:outline-none focus:ring-1 focus:ring-blue-700`} 
                    >
                    {field.options?.map((option) => (
                        <option 
                            key={`${field.field_id}-${option.value}`} 
                            value={option.value}>
                        {option.label}
                        </option>
                    ))}
                    </SelectChat>
                    <ChevronDown className="w-5 h-5 absolute inset-y-0 top-3 right-3 pointer-events-none text-gray-400" /> 
                </div>*/}
                </>
              ) : field.type === "radio" ? (
                field.options?.map((option) => (
                  <label key={`${field.field_id}-${option.value}-label`}
                    className="flex items-center space-x-2 cursor-pointer p-2  hover:bg-gray-100 transition-all"
                    > 
                    <InputChat
                      actionCode={Action.LEFT_FORM_DINAMICO} 
                      key={`${field.field_id}-${option.value}-input`}
                      type="radio"
                      name={field.nameStart}
                      value={option.value}
                      checked={formData[field.nameStart]||field.defaultValue === option.value?true:false}
                      onChange={handleChange}
                      className="w-4 h-4 text-blue-600 focus:ring-blue-500 focus:ring-2"
                    />
                    <span>{option.label}</span>
                  </label>
                ))
              ) : field.type === "api-search" ? (
                <div 
                  className="relative w-full" 
                  // Guardamos la referencia del contenedor para calcular la posición
                  ref={(el) => { searchInputRef.current[field.field_id] = el; }}
                >
                  <div className="relative flex items-center">
                    <InputChat
                      actionCode={Action.LEFT_FORM_DINAMICO}
                      type="text"
                      placeholder="Escribe para buscar..."
                      name={field.nameStart}
                      autoComplete="off" // Evita que el autocompletar del navegador tape el tuyo
                      value={formData[field.nameStart] || ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        setFormData(prev => ({ ...prev, [field.nameStart]: val }));
                        updateSearchPosition(field.field_id);
                        handleSearch(val, field);
                      }}
                      onFocus={() => {
                        updateSearchPosition(field.field_id);
                        // Si ya hay texto, intentar buscar de nuevo al ganar foco
                        if ((formData[field.nameStart] || "").length >= 4) {
                          handleSearch(formData[field.nameStart], field);
                        }
                      }}
                      className={`w-full border n-fmr-input pl-3 pr-10 py-2 ${errors[field.nameStart] ? "border-red-500" : "border-gray-300"} focus:outline-none focus:ring-1 focus:ring-blue-700`}
                    />

                    {formData[field.nameStart] && (
                      <button
                        type="button"
                        onClick={() => {
                          setFormData(prev => ({
                            ...prev,
                            [field.nameStart]: "",
                            [field.nameEnd]: "" 
                          }));
                          // Limpiamos resultados y cerramos
                          setSearchResults(prev => ({ ...prev, [field.field_id]: [] }));
                        }}
                        className="absolute right-3 text-gray-400 hover:text-red-500 z-10"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    )}
                  </div>
                  
                  {(searchResults[field.field_id]?.length > 0 || searchLoading[field.field_id]) && 
                    createPortal(
                      <ul 
                        className="fixed z-[9999] bg-white border border-gray-300 shadow-2xl rounded-md overflow-y-auto"
                        style={{
                          top: `${searchPosition[field.field_id]?.top || 0}px`,
                          left: `${searchPosition[field.field_id]?.left || 0}px`,
                          width: `${searchPosition[field.field_id]?.width || 0}px`,
                          maxHeight: '250px'
                        }}
                      >
                        {searchLoading[field.field_id] ? (
                          <li className="p-4 text-gray-400 text-sm animate-pulse">Buscando...</li>
                        ) : (
                          searchResults[field.field_id]?.map((item: any, idx: number) => (
                            <li
                              key={`${field.field_id}-res-${idx}`}
                              className="p-3 hover:bg-blue-600 hover:text-white cursor-pointer text-sm border-b last:border-b-0"
                              onClick={() => {
                                const campoResponseKey = field.apiConfig?.campo_response ?? "";
                                setFormData(prev => ({
                                  ...prev,
                                  [field.nameStart]: campoResponseKey ? item[campoResponseKey] : "" 
                                }));
                                setSearchResults(prev => ({ ...prev, [field.field_id]: [] }));
                              }}
                            >
                              <div className="font-bold">{item.razon_social}</div>
                              <div className="text-xs opacity-80">RUC: {item.ruc}</div>
                            </li>
                          ))
                        )}
                      </ul>,
                      document.body
                    )
                  }
                </div>
              ): field.type === "checkbox" ? (
                field.options?.map((option,index) => (
                    <label  
                        key={`${field.field_id}-${option.value}-${index}-label`}
                        className="flex items-center space-x-2 cursor-pointer p-2  hover:bg-gray-100 transition-all"
                        >
                        <InputChat
                          actionCode={Action.LEFT_FORM_DINAMICO} 
                          key={`${field.field_id}-${option.value}-${index}-input`}
                          type="checkbox"
                          name={field.nameStart}
                          value={option.value}
                          checked={(formData[field.nameStart]??[]).includes(option.value)}
                          onChange={handleChange}
                          className="w-4 h-4 text-blue-600 focus:ring-blue-500 focus:ring-2"
                        />
                        <span>{option.label}</span>
                  </label>
                ))

              ) : field.type === "file" ? (
                
                <InputChat
                  actionCode={Action.LEFT_FORM_DINAMICO} 
                  type="file"
                  key={`${field.field_id}`}
                  name={field.nameStart}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              ) : field.type === "date-range" ? (
                <>
                    <div className={`w-full bg-white flex space-x-2 border n-fmr-input px-8 py-2 ${(errors[field.nameStart]??'').length>0 ? "border-red-500" : "border-gray-300"} focus:outline-none focus:ring-1 focus:ring-blue-700`} >
                    <InputChat
                        actionCode={Action.LEFT_FORM_DINAMICO}
                        key={`${field.field_id}-start`}
                        name={field.nameStart} 
                        value={formData[field.nameStart] ? new Date(formData[field.nameStart]).toLocaleDateString('es-ES') : ""}  
                        onChange={handleChange}
                        onFocus={() => showCalendarPostion(true)} 
                        readOnly
                        className={`w-full n-border-bg-calendar`}
                        ref={inputRef}
                    />
                    <InputChat
                        actionCode={Action.LEFT_FORM_DINAMICO} 
                        type="text"
                        key={`${field.field_id}-end`}
                        name={field.nameEnd}
                        value={formData[field.nameEnd] ? new Date(formData[field.nameEnd]).toLocaleDateString('es-ES') : ""}  
                        onChange={handleChange}
                        onFocus={() => showCalendarPostion(true)} 
                        readOnly
                        className={`w-full n-border-bg-calendar`}
                        
                    />
                    </div>
                    {showCalendar && (
                        createPortal(
                        <div 
                            ref={calendarRef}
                            className=""
                            style={{
                            position: "absolute",
                            top: `${calendarPosition.top}px`,
                            left: `${calendarPosition.left}px`,
                            zIndex: 9999,
                            }}
                        >
                            <Calendar
                            selectRange={true}
                            onChange={(dates) => handleDateChange(dates as [Date | null, Date | null], field)}
                            value={[
                                formData[field.nameStart] ? new Date(formData[field.nameStart]) : null,
                                formData[field.nameEnd] ? new Date(formData[field.nameEnd]) : null,
                              ]}
                            locale="es-ES" 
                            
                            formatShortWeekday={(locale, date) =>
                                date.toLocaleDateString(locale, { weekday: 'short' }).charAt(0).toUpperCase()
                            }
                            className={`animate-fadeIn`}
                            />
                        </div>
                        ,document.body
                        )
                    )}
                  </>
              ) : (
                <InputChat
                  actionCode={Action.LEFT_FORM_DINAMICO} 
                  type={field.type}
                  key={`${field.field_id}`}
                  name={field.nameStart}
                  value={formData[field.nameStart] || field.defaultValue}
                  onChange={handleChange} 
                  className={`w-full border n-fmr-input px-3 py-2 ${errors[field.nameStart] ? "border-red-500" : "border-gray-300"} focus:outline-none focus:ring-1 focus:ring-blue-700`}
                />
              )
              
              } 
              {/* Errores */}
              {errors[field.nameStart] && (
                <p className="text-red-500 text-sm mt-1">{errors[field.nameStart]}</p>
              )}
            </div>
          ))}
  
          
            <ButtonChat
              actionCode={Action.LEFT_FORM_ENVIO}
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
            > 
              {frmLoading?'Loading ...':formSchema.labelButton}
            </ButtonChat>
 

        </form>

        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <div className="px-4 py-4">
            <h2 className="text-sm font-semibold mb-4">Respuesta API</h2>
            <p className="text-sm text-gray-600 mb-2 max-w-md">
              {frmResult?.mensaje?frmResult.mensaje:"No se encontró resultado intente mas tarde."}
            </p>
            {frmResult?.data_table && (
              
              <table className="min-w-[300px] border border-gray-300 text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-3 py-2 text-left">Campo</th>
                    <th className="border px-3 py-2 text-left">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(frmResult.data_table).map(([key, value]) => (
                    <tr key={key}>
                      <td className="border px-3 py-2 font-medium">{key}</td>
                      <td className="border px-3 py-2">{String(value)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <p className="text-sm mb-2 max-w-md truncate">
            {frmResult?.link?(
              <span className=" text-sm text-blue-600/100 cursor-pointer ml-2 underline underline-offset-4 " 
                onClick={() => window.open(frmResult?.link, "_blank")} 
                > {frmResult?.link} </span> 
            ):""}
            </p> 

          </div>
        </Modal>
      </div>
    );
  }